import React from 'react';
import { FormViewContent } from 'components/FormViewContent';
import atoms from 'ctsutheme/components/atoms';
import PropTypes from 'prop-types';
import { GetEmptyValue, BoolToString } from 'components';
import { RenderElement } from 'components/RenderHelpers';

const { Divider } = atoms;

const DTLInfo = ({ isDtlRqd, dtlTemplate }) => {
  const {
    revisionDate,
    tmplStatus
  } = dtlTemplate || {};

  return (
    <>
      <FormViewContent
        primaryText="DTL Required?"
        name="isDtlRqd"
        secondaryText={<BoolToString boolValue={isDtlRqd} />}
      />
      <RenderElement access={isDtlRqd}>
        <Divider />
        <FormViewContent
          primaryText="DTL Template Revision"
          name="revisionDate"
          secondaryText={<GetEmptyValue value={revisionDate} />}
        />
        <Divider />
        <FormViewContent
          primaryText="DTL Template Status"
          name="tmplStatus"
          secondaryText={<GetEmptyValue value={tmplStatus} />}
        />
      </RenderElement>
    </>
  );
};

DTLInfo.propTypes = {
  isDtlRqd: PropTypes.bool,
  dtlTemplate: PropTypes.oneOfType([PropTypes.object])
};

DTLInfo.defaultProps = {
  isDtlRqd: false,
  dtlTemplate: {}
};

export default DTLInfo;
